module.exports = __webpack_public_path__ + "static/lato-latin-900italic.3d7250ee.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-900italic.woff
// module id = ./node_modules/typeface-lato/files/lato-latin-900italic.woff
// module chunks = 17241999800008180000